<template>
    <div class="mb-5">
      <div class="columns is-mobile" style="width: 100%;">
        <!-- Flight information -->
        <div class="column is-7">
          <h1 class="is-size-3">
            {{ flight.departingAirport }} - {{ flight.arrivingAirport }}
          </h1>
          <h2 class="is-size-5 has-text-grey">
            Flight #{{ flight.marketingAirline.code }}{{ flight.flightNumber }}
          </h2>
          <h3 class="is-size-6 has-text-grey">
            Departing {{ flight.departingAt.date | formatDate }}
          </h3>
        </div>
        
        <!-- Seat selection -->
        <div class="column is-5">
          <!-- No seat selected yet -->
          <div v-if="!flight.selectedSeat" style="margin-top: 35%;">
            <!-- Seat map available -->
            <b-button
              v-if="hasSeatMap"
              class="is-block"
              style="margin: auto;"
              size="is-small"
              @click="$emit('select-seat')"
              type="is-primary"
              outlined
              expanded
            >
              <div v-if="preview">View Seats</div>
              <div v-else>Select Seat</div>
            </b-button>
            
            <!-- Seat map loading -->
            <b-button
              v-else-if="isLoading"
              :disabled="true"
              type="is-primary"
              size="is-small"
              expanded
            >
              Loading seat map...
            </b-button>
            
            <!-- Seat map unavailable -->
            <b-button
              v-else
              :disabled="true"
              type="is-dark"
              size="is-small"
              expanded
            >
              Seat map unavailable
            </b-button>
          </div>
          
          <!-- Seat already selected -->
          <div v-else style="margin-top: 20%;">
            <div style="margin-bottom: 5px;">
              <h1 class="is-size-6">
                Selected seat:
                <b class="is-size-5">{{ flight.selectedSeat.id }}</b>
              </h1>
            </div>
            <b-button
              class="is-block"
              style="margin: auto;"
              size="is-small"
              @click="$emit('select-seat')"
              type="is-primary"
              outlined
              expanded
            >
              Edit Selection
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'FlightLegItem',
    
    props: {
      flight: {
        type: Object,
        required: true
      },
      preview: {
        type: Boolean,
        default: false
      },
      hasSeatMap: {
        type: Boolean,
        default: false
      },
      isLoading: {
        type: Boolean,
        default: false
      }
    }
  }
  </script>
  
  <style scoped>
  /* Add any specific styles for this component here */
  </style>